import React, { createContext, useState, useMemo, useEffect } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';

export const ThemeContext = createContext();

export const ThemeContextProvider = ({ children }) => {
  const savedTheme = localStorage.getItem('darkMode');
  const [darkMode, setDarkMode] = useState(savedTheme === 'true');
  const [direction, setDirection] = useState('ltr');

  useEffect(() => {
    const currentLang = localStorage.getItem('i18nextLng');
    setDirection(currentLang === 'ar' ? 'rtl' : 'ltr');
  }, []);

  const theme = useMemo(
    () =>
      createTheme({
        direction: direction,
        palette: {
          mode: darkMode ? 'dark' : 'light',
          primary: { main: '#0b71f3', },
          secondary: { main: '#4CAF50', },
          gray1: { main: '#808080' }
        },
        typography: { fontFamily: 'Trebuchet MS, Roboto, Ubuntu, sans-serif' },
        components: {
          MuiOutlinedInput: {
            styleOverrides: {
              root: {
                height: '35px',
                '& fieldset': {
                  borderColor: darkMode ? '#2e3338' : '#e8e8e8',
                },
                '&:hover fieldset': {
                  borderColor: '#3183ff',
                },
                '&.Mui-focused fieldset': {
                  borderColor: '#3183ff',
                },
              },
            },
          },
          MuiFilledInput: {
            styleOverrides: {
              root: {
                height: '25px',
                padding: "0 !important",
                '& fieldset': {
                  backgroundColor: 'transparant'
                },
              },
            },
          },
          MuiAppBar: {
            styleOverrides: {
              root: {
                boxShadow: 'none',
              },
            },
          },
          MuiTableContainer: {
            styleOverrides: {
              root: {
                boxShadow: 'none',
              },

            },
          }
        },
      }),
    [darkMode, direction]
  );

  const toggleTheme = () => {
    const newDarkMode = !darkMode;
    setDarkMode(newDarkMode);
    // document.body.classList.toggle('dark-mode');
    localStorage.setItem('darkMode', newDarkMode);
  };

  // Update the body's background color based on darkMode
  useEffect(() => {
    if (darkMode) {
      document.body.style.setProperty('--background-color', '#151924');
    } else {
      document.body.style.setProperty('--background-color', '#fff');
    }
  }, [darkMode]);

  return (
    <ThemeContext.Provider value={{ darkMode, toggleTheme, setDirection, direction }}>
      <ThemeProvider theme={theme}>
        {children}
      </ThemeProvider>
    </ThemeContext.Provider>
  );
};
